

export function checkToken(){
    let cookies =  document.cookie.split(';')
    let flag =  cookies.some(cookie=>{
        let item = cookie.trim();
        return item.startsWith(process.env.token+ '=')
    })
    // return true
    return flag
}

export function maskMemberId(memberId?: string | number): string {
    if (memberId === null || memberId === undefined) {
        return '';
    }

    const value = String(memberId).trim();
    if (!value) {
        return '';
    }

    if (value.length <= 4) {
        return value;
    }

    const visible = value.slice(-4);
    return value.slice(0, -4).replace(/./g, '*') + visible;
}

export const fmtMoney = (n: number) => `$ ${(Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

export function removeLeadingSemicolon(value: any) {
    if (typeof value !== "string") {
        return value;
    }
    return value.replace(/^;\s*/, "");
}

export function addLeadingSemicolon(value: any) {
    if (typeof value !== "string" || !value) {
        return value;
    }
    return value.startsWith(";") ? value : `;${value}`;
}

